import script from "./Aboutme.vue?vue&type=script&setup=true&lang=js"
export * from "./Aboutme.vue?vue&type=script&setup=true&lang=js"

import "./Aboutme.vue?vue&type=style&index=0&id=b9c9e076&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9c9e076"]])

export default __exports__